import axios from '@/utils/request'

export default {
	// 2021-01-09
	create(params) {
		return axios.post('/mms/purcahse-materials', params)
	},
	// 2021-01-09
	findByPurchaseUuid(params) {
		return axios.get('/mms/purcahse-materials/find-by-purchase-uuid', params)
	},
	// 2021-01-09
	update(id, params) {
		return axios.put('/mms/purcahse-materials/' + id, params)
	},
	// 2021-01-09
	delete(id) {
		return axios.delete('/mms/purcahse-materials/' + id)
	},
	// 2021-01-09
	afresh(params) {
		return axios.put('/mms/purcahse-materials/afresh', params)
	},
	// 2021-04-14
	asyncToProduct(uuid, params) {
		return axios.put('/mms/purcahse-materials/' + uuid + '/async-to-product', params)
	},
	// 2021-04-19
	addNoMatieral(params) {
		return axios.put('/mms/purcahse-materials/add-no-matieral', params)
	},
	// 2021-12-27
	beforeFeedCalc(params) {
		return axios.put('/mms/purcahse-materials/before-feed-calc', params)
	},
}

